import React, {useEffect} from 'react';
import {StyleSheet} from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  withSequence,
  runOnJS,
} from 'react-native-reanimated';

import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import CCText from '@/Atoms/CCText';

interface Props {
  isCorrect: boolean;
  onDismiss: () => void;
}

export default function PuzzleMoveResult({isCorrect, onDismiss}: Props) {
  const opacity = useSharedValue(0);

  const animStyle = useAnimatedStyle(() => ({opacity: opacity.value}));

  useEffect(() => {
    opacity.value = withSequence(
      withTiming(1, {duration: 200}),
      withTiming(1, {duration: 1100}),
      withTiming(0, {duration: 200}, finished => {
        if (finished) runOnJS(onDismiss)();
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusColor = isCorrect ? CCColors.Green : CCColors.Error;

  return (
    <Animated.View
      style={[
        styles.overlay,
        {borderColor: statusColor},
        animStyle,
      ]}>
      <CCText
        style={[styles.icon, {color: statusColor}]}
        fontSize={FontSizes[24]}>
        {isCorrect ? '✓' : '✗'}
      </CCText>
      <CCText
        style={styles.label}
        fontSize={FontSizes[20]}
        fontWeight="bold"
        color={CCColors.TextColor.Dark}>
        {isCorrect ? 'Correct!' : 'Incorrect'}
      </CCText>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255,255,255,0.92)',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 20,
    borderRadius: 12,
    borderWidth: 2,
  },
  icon: {
    marginBottom: 8,
  },
  label: {
    textAlign: 'center',
  },
});
